/* GET LEAD_PRICES */
export const GET_ADMIN_LEAD_PRICES = "GET_ADMIN_LEAD_PRICES"
export const GET_ADMIN_LEAD_PRICES_SUCCESS = "GET_ADMIN_LEAD_PRICES_SUCCESS"
export const GET_ADMIN_LEAD_PRICES_ERROR = "GET_ADMIN_LEAD_PRICES_ERROR"

/* UPDATE LEAD_PRICES */
export const UPDATE_ADMIN_LEAD_PRICE = "UPDATE_ADMIN_LEAD_PRICE"
export const UPDATE_ADMIN_LEAD_PRICE_SUCCESS = "UPDATE_ADMIN_LEAD_PRICE_SUCCESS"
export const UPDATE_ADMIN_LEAD_PRICE_ERROR = "UPDATE_ADMIN_LEAD_PRICE_ERROR"